//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            isDisable:false,
            pickerdate:"",
          arr:[],
            cities:['月经期','怀孕期','临产期','哺乳期','术后恢复期'],
             message:'',
            patientInfo: {
                symptom: "",
                height: "",
                weight: "",
                allergichistory: "",
                pastcase: "",
                orderid: "",
                parientid: ""
            },
            orderID: "",
            userInfo: {}
        };
    },
    created() {
        this.orderID = this.$route.query.orderId;
        this.userInfo = this.$store.state.userInfo;
        document.title="问诊资料";
        let sexAll=this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientSex=='1'?'男':'女';
        this.pickerdate=this.userInfo.age?(sexAll+' '+this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientAge+'岁'):'';
    },
    methods: {
        updateTop(){
            window.scroll(0,0);
        },
      checkedBox(i) {
        if (this.arr.indexOf(i) != -1) {
          this.arr.splice(this.arr.indexOf(i), 1);
          this.message='';
        } else {
          if(this.arr.length>0){
            this.arr.splice(0,1);
          }
          this.arr.push(i);
          this.message = i;
        }
      },
        sendDoctor() {
            this.isDisable=true;
          setTimeout(()=>{
            this.isDisable=false   //点击一次时隔两秒后才能再次点击
          },2000)
            var _this = this;
            var reg = /(^[1-9]\d*$)/;
            if (this.patientInfo.symptom == "") {
                this.$toastMsg("请填写病症自述");
                return false;
            }
            if (this.patientInfo.height == "") {
                this.$toastMsg("请填写身高,单位（cm）");
                return false;
            }
            if (this.patientInfo.weight == "") {
                this.$toastMsg("请填写体重,单位（KG）");
                return false;
            }
            if(!reg.test(this.patientInfo.height) || !reg.test(this.patientInfo.weight)){
                this.$toastMsg('请输入整数');
                return false;
            }
            this.patientInfo.orderid = this.orderID;
            this.patientInfo.parientid = this.userInfo.id;
            this.patientInfo.specialperiod = this.message;
            this.$doRequest("/api/Inquiry/complainedModified",_this.patientInfo,res => {
                _this.$toastMsg("提交成功");
                var ext = {
                    businessType: "patient_profile",
                    orderid: _this.$route.query.orderId,
                  businessBody:{
                    patientname: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientName,
                    patientnickname: _this.$store.state.userInfo.patientnickname,
                    sex: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientSex,
                    age: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientAge,
                    symptom:_this.patientInfo.symptom
                  }
                };
                _this.$sendPrivateText(_this,_this.$store.state.AllOfValue.ImDoctorInfo.doctorId,"我已上传问诊资料",function(msg) {
                    _this.$router.push({ path: "/im" });
                    var data = {
                        fromid: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
                        toid: _this.messages.doctorId,
                        msgtype: "3",
                        val: "患者已上传问诊单",
                        fromType: "2",
                        fromName: _this.$store.state.userInfo.patientnickname,
                        orderid: _this.$route.query.orderId
                    };
                    _this.$doRequest("/api/ImUtil/signIm", data, function(res) {
                    });
                },ext);
            });
        },
        routerTo() {
            var _this = this;
            this.$router.push({ path: "/three", query: { orderId: _this.orderID } });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/upload/two/two.vue